import React, { useState, useEffect } from 'react';
import { withRouter, NavLink, Link } from 'react-router-dom';
import moment from 'moment';
import { orderBy } from 'natural-orderby';
import { Spinner } from 'reactstrap';
import Modal from '../../../components/Modal';
import SelfPDFViewer from '../../../components/PDFViewer';
import ToastUtil from '../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../components/SweetAlert';
import { newFetch, GET, DELETE } from '../../../helpers/fetch';

import { config } from '../../../config';

const { SERVER_URL } = config;

const EDocs = ({ history }) => {
  const clientID = parseInt(localStorage.getItem('client'), 10);
  const sortOptions = ['Title', 'Date Created'];
  const [clients, setClients] = useState([]);
  const [activeClient, setActiveClient] = useState(0);
  const [activeSort, setActiveSort] = useState('Title');
  const [initialDocs, setInitialDocs] = useState([]);
  const [docs, setDocs] = useState([]);
  const [sortedDocs, setSortedDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeDoc, setActiveDoc] = useState(null);

  const fetchClients = async () => {
    setLoading(true)
    let api_path = `/client/${clientID}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setClients(response.data);
      setLoading(false)
    }
  };

  const fetchDocs = async () => {
    let api_path = `/edoc`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let docsData = response.data;
      let sorted = orderBy(docsData, [(doc) => doc.title]);
      setInitialDocs(sorted);
      setDocs(sorted);
    }
  };

  const handlePreviewDoc = async (doc_id) => {
    let doc = docs.find((doc) => doc.id === doc_id);
    setActiveDoc(doc);
    history.push('/edocs/preview', {
      activeDoc: doc,
    });
  };

  const handleDeleteDoc = async (doc_id) => {
    const isConfirmed = await AlertService.confirm(
      '',
      'Are you sure you want to delete this Document?'
    );
    if (isConfirmed) {
      let api_path = `/edoc/${doc_id}`;
      let response = await newFetch(DELETE, api_path);

      if (response.success) {
        ToastUtil.success(response.message);
        window.location.reload();
      }
    }
  };

  useEffect(() => {
    fetchDocs();
    setActiveClient(clientID);
  }, []);

  useEffect(() => {
    const filteredDocs =
      clientID === 0
        ? initialDocs
        : initialDocs.filter((x) => x.client_id === clientID);

    setDocs(filteredDocs);
    fetchClients();
  }, [clientID, initialDocs]);

  // sort function
  useEffect(() => {
    if (docs.length > 0 && activeSort) {
      switch (activeSort) {
        case 'Title':
          let titleSorted = orderBy(docs, [(doc) => doc.title]);
          setSortedDocs(titleSorted);
          break;

        case 'Date Created':
          let dateSorted = docs.sort((a, b) => {
            if (moment(a.createdAt).isBefore(moment(b.createdAt))) return 1;
            else if (moment(a.createdAt).isAfter(moment(b.createdAt)))
              return -1;
            else return 0;
          });
          setSortedDocs(dateSorted);
          break;

        case 'File Size':
          let sizeSorted = [];
          setSortedDocs(sizeSorted);
          break;

        default:
          break;
      }
    }
  }, [docs, activeSort]);

  return (
    <>
      <div
        className="container-fluid"
        style={{ paddingLeft: '2rem', paddingRight: '2rem' }}
      >
        <div className="border-bottom pb-3 py-2 d-flex align-items-center">
          <h6 className="flex-grow-1 pt-4" style={{ color: '#5156BE' }}>
            eDocs
          </h6>
          {clients.enable_edocs && <NavLink
            to="/edocs/add"
            className="text-decoration-none"
            style={{ color: 'inherit' }}
          >
            <button
              className="btn btn-outline-brand ms-3 mt-2 adjust-fs adjust-shadow"
              style={{ width: '200px' }}
            >
              Add New
            </button>
          </NavLink>}
        </div>
        {clients.enable_edocs ?
        <>
        <div className="d-flex flex-row align-items-center justify-content-between py-3">
          <h5 className="flex-grow-1">eDocs ({docs.length})</h5>
          <div className="d-flex align-items-center">
            <div className="pe-2">Sort By:</div>
            <select
              id="sortRewards"
              className="form-select adjust-fs"
              style={{ width: '200px' }}
              onChange={({ target: { value } }) => setActiveSort(value)}
            >
              {sortOptions.map((option, index) => (
                <option key={`option-${index}`} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="table-responsive rounded shadow bg-white">
          <table className="table table-borderless mb-0">
            <thead className="border-bottom">
              <tr>
                <th className="py-3 text-muted fw-normal px-3">Title</th>
                <th className="py-3 text-muted fw-normal px-3">Client</th>
                <th width="15%" className="py-3 text-muted fw-normal px-3">
                  Date Created
                </th>
                {/* <th width="10%">File Size</th> */}
                <th width="10%"></th>
              </tr>
            </thead>
            
            {loading ? (
            <tbody>
              <tr>
                <td colSpan={4} className="text-center py-12">
                  <div className="flex justify-center items-center">
                    <Spinner />
                  </div>
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody className="p-3">
              {docs.length > 0 ? (
                sortedDocs.map((doc) => (
                  <tr key={doc.id}>
                    {/* <td width="10%" onClick={() => handlePreviewDoc(doc.id)}>
                      <img src={`${SERVER_URL}/${doc.file}`} alt="" />
                    </td> */}
                    <td
                      className="text-muted"
                      style={{ cursor: 'pointer' }}
                      onClick={() => handlePreviewDoc(doc.id)}
                    >
                      {doc.title}
                    </td>
                    {/* <td>{clients[clients.map(x => x.id).indexOf(doc.client_id)].name}</td> */}
                    <td className="text-muted">{doc.client.name}</td>
                    <td width="15%" className="text-muted">
                      {moment(doc.createdAt).format('DD MMMM YYYY')}
                    </td>
                    {/* <td width="10%">File Size</td> */}
                    <td className="text-center align-items-center text-muted">
                      <div
                        style={{ cursor: 'pointer' }}
                        className="dropdown custom-dropdown"
                      >
                        <button
                          className="btn dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i
                            className="fas fa-ellipsis-h adjust-fs"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          ></i>
                        </button>
                        <div
                          className="dropdown-menu dropdown-menu-right"
                          style={{ width: '150px' }}
                        >
                          <Link
                            to={`/edocs/doc/${doc.id}/edit`}
                            style={{ cursor: 'pointer' }}
                            className="dropdown-item border-bottom pb-2 adjust-fs"
                          >
                            Edit
                          </Link>
                          <div
                            onClick={() => handlePreviewDoc(doc.id)}
                            style={{ cursor: 'pointer' }}
                            className="dropdown-item pt-2 adjust-fs"
                          >
                            Preview
                          </div>
                          <div
                            onClick={() => handleDeleteDoc(doc.id)}
                            style={{ cursor: 'pointer' }}
                            className="dropdown-item pt-2 adjust-fs"
                          >
                            Delete
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="border-bottom">
                  <td colSpan="5" className="text-center py-4">
                    No docs found
                  </td>
                </tr>
              )
            }
              </tbody>
            )}
            
          </table>
        </div>
        </> : 
        (!loading && <div className="text-muted pt-4">
          The client does not have access to this module.
        </div>)
        }
      </div>
    </>
  );
};

export default withRouter(EDocs);
